import { articles, categories, type Article, type CategoryMeta } from '@/mocks/articles';

export function getCategory(id: string | undefined): CategoryMeta | undefined {
  return categories.find((c) => c.id === id);
}

export function getArticleById(id: string | undefined): Article | undefined {
  const num = Number(id);
  return articles.find((a) => a.id === num);
}

export function getArticleBySlug(slug: string | undefined): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function listByCategory(categoryId: string): Article[] {
  return articles.filter((a) => a.categoryId === categoryId);
}

export function relatedArticles(article: Article, limit = 4): Article[] {
  const same = articles.filter((a) => a.categoryId === article.categoryId && a.id !== article.id);
  const fill = articles.filter((a) => a.categoryId !== article.categoryId);
  return [...same, ...fill].slice(0, limit);
}

export function hotArticles(limit = 6): Article[] {
  return [...articles].sort((a, b) => b.heat - a.heat).slice(0, limit);
}

export function latestArticles(limit = articles.length): Article[] {
  return [...articles].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, limit);
}

export function categoryName(id: string | undefined): string {
  return getCategory(id)?.name ?? '校园爆料';
}

export function formatHeat(n: number): string {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}w`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
  return `${n}`;
}

export function formatLike(n: number): string {
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
  return `${n}`;
}